import React, {PureComponent} from 'react';
import http from '../../../services/httpService';
import InputRegular from '../../common/InputRegular';
import ReactIntlTelInput from 'react-intl-tel-input-v2';
import countries from '../../common/countries';
import {Button, MenuItem} from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";
import usStates from '../../common/usStates';
import StripeReplacementModal from '../../modals/StripeReplacementModal';
import VatCheckFailedModal from '../../modals/VatCheckFailedModal';
import { getJwt } from '../../../services/authService';

class AddFundsStep2 extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            country: '',
            countryName: 'Select Country',
            filteredStates: [],
            usState: 'Select State',
            companyName: '',
            billingName: '',
            address1: '',
            phone: {
                iso2: 'us',
                dialCode: '1',
                phone: ''
            },
            email: '',
            postalCode: '',
            city: '',
            vatNumber: '',
            poNumber: '',
            filteredCountries: [],
            fieldsCheckActive: false,
            errorsList: [],
            listOfEuAbbreviations: ['BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'GR', 'HR', 'IT', 'CY', 'LV',
                'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE', 'UK', 'GB'],
            shouldAddVat: false,
            vatCheckedModalIsOpen: false,
            initialDataAdded: false,
            stripeReplacementModal: false
        };
    }

    componentDidMount() {
        this.setState({
            filteredCountries: countries,
            companyName: this.props.companyName,
            billingName: this.props.billingName,
            email: this.props.email,
            filteredStates: usStates,
            phone: {
                iso2: this.props.phone ? '' : 'us',
                dialCode: this.props.phone ? '' : '1',
                phone: this.props.phone
            }
        })
    }

    componentDidUpdate(){
        if(!this.state.initialDataAdded && (this.props.companyName || this.props.email)){
            if(this.state.phone.phone !== this.props.phone){
                this.setState({
                    phone: {
                        iso2: this.props.phone ? '' : 'us',
                        dialCode: this.props.phone ? '' : '1',
                        phone: this.props.phone
                    }
                })
            }
            if(this.state.companyName !== this.props.companyName){
                this.setState({
                    companyName: this.props.companyName
                })
            }
            if(this.state.billingName !== this.props.billingName){
                this.setState({
                    billingName: this.props.billingName
                })
            }
            if(this.state.email !== this.props.email){
                this.setState({
                    email: this.props.email
                })
            }
            if(this.state.city !== this.props.city){
                this.setState({
                    city: this.props.city
                })
            }
            if(this.state.country !== this.props.country){
                this.setState({
                    country: this.props.country
                })
            }
            if(this.state.usState !== this.props.usState){
                this.setState({
                    usState: this.props.usState
                })
            }
            if(this.state.vatNumber !== this.props.vatNumber){
                this.setState({
                    vatNumber: this.props.vatNumber
                })
            }
            if(this.state.poNumber !== this.props.poNumber){
                this.setState({
                    poNumber: this.props.poNumber
                })
            }
        }
    }

    filterItems = (q) => {
        function escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        }

        const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
        const hasTrailingSpace = q.endsWith(" ");
        const searchRegex = new RegExp(
            words
            .map((word, i) => {
                if (i + 1 === words.length && !hasTrailingSpace) {
                    // The last word - ok with the word being "startswith"-like
                    return `(?=.*\\b${escapeRegExp(word)})`;
                } else {
                    // Not the last word - expect the whole word exactly
                    return `(?=.*\\b${escapeRegExp(word)}\\b)`;
                }
            })
            .join("") + ".+",
            "gi"
        );
        // console.log('Words: ', words)
        let filteredArray = [];
        countries.filter(item => {
            let imamIme = searchRegex.test(item.name);
            searchRegex.lastIndex = 0;
            return imamIme ? filteredArray.push(item) : null;
        });
        this.setState({
            filteredCountries: filteredArray
        })
    };

    filterStates = (q) => {
        function escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        }

        const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
        const hasTrailingSpace = q.endsWith(" ");
        const searchRegex = new RegExp(
            words
            .map((word, i) => {
                if (i + 1 === words.length && !hasTrailingSpace) {
                    // The last word - ok with the word being "startswith"-like
                    return `(?=.*\\b${escapeRegExp(word)})`;
                } else {
                    // Not the last word - expect the whole word exactly
                    return `(?=.*\\b${escapeRegExp(word)}\\b)`;
                }
            })
            .join("") + ".+",
            "gi"
        );
        // console.log('Words: ', words)
        let filteredArray = [];
        usStates.filter(item => {
            let imamIme = searchRegex.test(item.name);
            searchRegex.lastIndex = 0;
            return imamIme ? filteredArray.push(item) : null;
        });
        this.setState({
            filteredStates: filteredArray
        })
    };

    updateBillingDetails = async (name, value) =>{
        // console.log('updateBillingDetails', name, value, this.state)
        if (name !== 'phone'){
            await this.setState({
                [name]: value
            })
        }

        await this.props.updateBillingDetails(name, value)

        // await this.props.updateBillingDetails({
        //     companyName: this.state.companyName,
        //     billingName: this.state.billingName,
        //     address1: this.state.address1,
        //     address2: this.state.address2,
        //     postalCode: this.state.postalCode,
        //     phone: this.getFullPhoneNumber(this.state.phone),
        //     email: this.state.email,
        //     city: this.state.city,
        //     country: this.state.country,
        //     usState: this.state.usState,
        //     vatNumber: this.state.vatNumber,
        //     poNumber: this.state.poNumber,
        //     shouldAddVat: this.state.shouldAddVat
        // })
    }

    handleSubmit = async () => {
        await this.setState({fieldsCheckActive: true})
        let anyErrorActive = await false;
        await this.state.errorsList.map(error=>error ? anyErrorActive = true : '')
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let shouldAddVat = this.state.shouldAddVat;
        let vat_number = this.state.vatNumber;
        let country = this.state.country;
        let vatChecked = false;

        // console.log('anyErrorActive: ', anyErrorActive, this.state.errorsList)
        if(!anyErrorActive && this.state.country && this.state.phone.phone && this.isPhoneNumber() && ((this.state.usState && (this.state.usState !== 'Select State')) || (this.state.country !== 'US'))){
            if(vat_number && country && shouldAddVat){
                try {
                    // const checkVatResult = await http.post('api/user/' + this.props.user.id + '/project/' + projectId + '/test_vat', {
                    //     "vat_number": vat_number
                    // }, { headers: { authorization: getJwt() } });
                    const checkVatResult = await http.post('api/user/' + this.props.user.id + '/project/' + projectId + '/test_vat', {
                        "vat_number": this.state.vatNumber,
                    }, { headers: { authorization: getJwt() } });
                    if(checkVatResult.data.vat_details && checkVatResult.data.vat_details.valid){
                        await this.updateBillingDetails('shouldAddVat', false)
                        this.props.handleStepChange(3);
                    }else{
                        this.setState({vatCheckedModalIsOpen: true});
                    }
                }catch(e){
                    this.setState({vatCheckedModalIsOpen: true});
                }
            }else{
                this.props.handleStepChange(3);
            }

        }
        // await this.setState({fieldsCheckActive: false})
    }

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
        // console.log('Errors list data: ', error, id, errorsList);
    }

    getFullPhoneNumber = (phoneObject) =>{
        let phone = phoneObject.phone.toString();
        let dialCode = phoneObject.dialCode;

        if (phone.startsWith('00')){
            phone = phone.substring(2);
            phone = '+' + phone;
            return phone
        } else if (phone.startsWith('0')){
            phone = phone.substring(1);
            phone = '+' + dialCode + phone;
            return phone
        } else if (phone.startsWith('+')){
            return phone
        } else if(phone && (phone !== '+')) {
            phone = '+' + dialCode + phone;
            return phone
        } else {
            return ''
        }
    }

    isPhoneNumber = () => {
        let phone = this.state.phone.phone;
        var regEx = /^[+-]?\d+$/;
        if (regEx.test(phone) && phone.length > 6) {
            return true
        } else {
            return false
        }
    }

    handleContinueAnyway = async () => {
        await this.setState({vatNumber: ''});
        await this.updateBillingDetails('vatNumber', '');
        this.props.handleStepChange(3);
    }

    render() {
        const inputProps = {
            placeholder: '+' + this.state.phone.dialCode + ' *********',
        };

        const intlTelOpts = {
            preferredCountries: [],
        };
        const onReady = (instance, IntlTelInput) => console.log('');
        return (
            <div className='add-funds-content-container'>
                <div className='white-wrapper'>
                    <h2>Billing Details</h2>
                    <div style={{margin: '10px 0'}}>
                        <InputRegular
                            id="1"
                            label1="Company Name"
                            placeholder=""
                            required={true}
                            type='text'
                            onChange={ value => this.updateBillingDetails('companyName', value) }
                            value={this.props.companyName}
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            updateErrorsList={this.updateErrorsList}
                            errorMessage="This field is required"
                        />
                    </div>
                    <div style={{margin: '10px 0'}}>
                        <InputRegular
                            id="2"
                            label1="Billing Name"
                            placeholder=""
                            type='text'
                            required={true}
                            onChange={ value => this.updateBillingDetails('billingName', value) }
                            value={this.props.billingName}
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            updateErrorsList={this.updateErrorsList}
                            errorMessage="This field is required"
                        />
                    </div>
                    <div style={{margin: '10px 0'}}>
                        <InputRegular
                            id="4"
                            label1="Email"
                            placeholder=""
                            type='email'
                            required={false}
                            onChange={ value => this.updateBillingDetails('email', value) }
                            value={this.props.email}
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            // updateErrorsList={this.updateErrorsList}
                            // errorMessage="This field is required"
                        />
                    </div>
                    <div style={{margin: '10px 0'}}>
                        <p htmlFor="post-link" className='full-row-label'>Phone</p>
                        <ReactIntlTelInput
                            className={((this.state.phone.phone === '') || !this.isPhoneNumber() ) && this.state.fieldsCheckActive ? 'onboard-tel error' : this.state.phone.phone === '' ? '' : 'onboard-tel valid'}
                            inputProps={inputProps}
                            intlTelOpts={intlTelOpts}
                            value={this.state.phone}
                            onChange={(e) => {
                                this.setState({
                                    phone: e
                                })
                                this.updateBillingDetails('phone', this.getFullPhoneNumber(e))
                            }}
                            onReady={onReady}
                        />
                        {
                            ((this.state.phone.phone === '') || !this.isPhoneNumber() )&& this.state.fieldsCheckActive ?
                                <div className="selector-error-label">Valid phone number is required</div>
                                :
                                <div className='selector-error-label'></div>
                        }
                    </div>
                    <div style={{margin: '10px 0'}}>
                        <InputRegular
                            id="3"
                            label1="Address"
                            placeholder=""
                            type='text'
                            required={true}
                            onChange={ value => this.updateBillingDetails('address1', value) }
                            value={this.props.address1}
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            updateErrorsList={this.updateErrorsList}
                            errorMessage="This field is required"
                        />
                    </div>
                    <div className="flex-direction-row justify-content-space flex-mobile-column">
                        <div className='width-48'>
                            <InputRegular
                                id="5"
                                label1="Postal Code"
                                placeholder=""
                                required={true}
                                type='text'
                                onChange={ value => this.updateBillingDetails('postalCode', value) }
                                value={this.props.postalCode}
                                fieldsCheckActive={this.state.fieldsCheckActive}
                                updateErrorsList={this.updateErrorsList}
                                errorMessage="This field is required"
                            />
                        </div>
                        <div className='width-48'>
                            <InputRegular
                                id="6"
                                label1="City"
                                placeholder=""
                                required={true}
                                type='text'
                                onChange={ value => this.updateBillingDetails('city', value) }
                                value={this.props.city}
                                fieldsCheckActive={this.state.fieldsCheckActive}
                                updateErrorsList={this.updateErrorsList}
                                errorMessage="This field is required"
                            />
                        </div>
                    </div>
                    <Select
                        items={this.state.filteredCountries}
                        itemRenderer={(item, index)=> <MenuItem
                            key={index}
                            onClick={async () => {
                                let checkEuVat = await false;
                                await this.state.listOfEuAbbreviations.map(country=>country === item.code ? checkEuVat = true : '');
                                await this.updateBillingDetails('country', item.code)
                                await this.updateBillingDetails('countryName', item.name)
                                await this.updateBillingDetails('shouldAddVat', checkEuVat)
                            }}
                            text={item.name + ' ' + item.flag}
                        /> }
                        filterable={true}
                        onQueryChange={this.filterItems}
                        resetOnClose={true}
                    >
                        <p style={{fontSize: 12, marginBottom: 0}}>Country</p>
                        <Button
                            className={(this.state.countryName === 'Select Country') && this.state.fieldsCheckActive ? 'country-selector-error' : this.state.countryName === 'Select Country' ? 'country-selector-empty' : 'country-selector'}
                            text={ this.state.countryName }
                            rightIcon="caret-down">
                        </Button>

                    </Select>
                    {
                        (this.state.countryName === 'Select Country') && this.state.fieldsCheckActive ?
                            <div className="selector-error-label">This field is required</div>
                            :
                            <div className="selector-error-label"></div>
                    }
                    {this.state.country === 'US' ?
                        <div>
                            <Select
                                items={this.state.filteredStates}
                                itemRenderer={(item, index)=> <MenuItem
                                    key={index}
                                    onClick={() => {
                                        this.updateBillingDetails('usState', item.abbreviation)
                                    }}
                                    text={item.name}
                                /> }
                                filterable={true}
                                onQueryChange={this.filterStates}
                                resetOnClose={true}
                            >
                                <p style={{fontSize: 12, marginBottom: 0}}>State</p>
                                <Button
                                    className={((this.props.usState === 'Select State')|| !this.props.usState) && this.state.fieldsCheckActive ? 'country-selector-error' : this.state.usState === 'Select State' ? 'country-selector-empty' : 'country-selector'}
                                    text={ this.props.usState || 'Select State' }
                                    rightIcon="caret-down">
                                </Button>

                            </Select>
                            {
                                ((this.props.usState === 'Select State')|| !this.props.usState) && this.state.fieldsCheckActive ?
                                    <div className="selector-error-label" style={{marginTop: 5}}>This field is required</div>
                                    :
                                    <div className='selector-error-label' style={{marginTop: 5}}></div>
                            }
                        </div>
                        :
                        ''
                    }

                    <div className="flex-direction-row justify-content-space flex-mobile-column">
                        <div className='width-48'>
                            <InputRegular
                                id="7"
                                label1="VAT Number"
                                placeholder=""
                                required={false}
                                type='text'
                                onChange={value => this.updateBillingDetails('vatNumber', value)}
                                value={this.props.vatNumber}
                                fieldsCheckActive={this.state.fieldsCheckActive}
                                // updateErrorsList={this.updateErrorsList}
                                // errorMessage="This field is required"
                            />
                        </div>
                        <div className='width-48'>
                            <InputRegular
                                id="8"
                                label1="PO Number"
                                placeholder=""
                                required={false}
                                type='number'
                                onChange={ value => this.updateBillingDetails('poNumber', value) }
                                value={this.props.poNumber}
                                fieldsCheckActive={this.state.fieldsCheckActive}
                                // updateErrorsList={this.updateErrorsList}
                                // errorMessage="This field is required"
                            />
                        </div>
                    </div>
                    {/*{console.log('ErrorsList: ', this.state.errorsList, this.state.country, this.state.phone.phone)}*/}
                    <button onClick={this.handleSubmit}>Proceed to Checkout</button>
                    {/*<button onClick={()=>this.setState({stripeReplacementModal:true})}>Proceed to Checkout</button>*/}
                    {/*<StripeReplacementModal*/}
                    {/*    showModal={this.state.stripeReplacementModal}*/}
                    {/*    handleClose={() => this.setState({stripeReplacementModal: false})}*/}
                    {/*    maxWidth={600}*/}
                    {/*    history={this.props.history}*/}
                    {/*    user={this.props.user}*/}
                    {/*    updateUserFromServer={this.props.updateUserFromServer}*/}
                    {/*/>*/}
                    <p className='grey-text text-align-center margin-top-10'>You won't be charged yet</p>
                </div>
                <VatCheckFailedModal
                    showModal={this.state.vatCheckedModalIsOpen}
                    handleClose={()=>this.setState({vatCheckedModalIsOpen: false})}
                    maxWidth={500}
                    handleContinueAnyWay={this.handleContinueAnyway}
                />
            </div>
        )
    }
}

export default AddFundsStep2;